module.exports = __webpack_public_path__ + "img/toolbar-bg-left.897ac877.jpg";